import React from 'react';
import { pluralizeString } from '../helpers/utils';
import Layout from '../components/layout/Layout';
import { useAuth } from 'react-oidc-context';
import CredentialHome from '../features/credential/CredentialHome';
interface WalletHome {
  showWelcome: boolean;
}

/**
 * @description Wallet home component
 * @param {WalletHome} { showWelcome }
 * @return {React.FC}
 */
const WalletHome: React.FC<WalletHome> = ({ showWelcome }) => {
  const authContext = useAuth();
  const first_name = String(authContext.user?.profile.given_name);
  const headerTitle = `${pluralizeString(first_name)} Digital Wallet`;
  return (
    <Layout title={headerTitle} scrollViewProps={{ minHeight: '100%' }}>
      <CredentialHome showWelcome={showWelcome} />
    </Layout>
  );
};

export default WalletHome;
